import { render, staticRenderFns } from "./ProfileMyProfileAddLinkedAccountModal.vue?vue&type=template&id=720baeef&scoped=true&"
import script from "./ProfileMyProfileAddLinkedAccountModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileMyProfileAddLinkedAccountModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720baeef",
  null
  
)

export default component.exports